import template from './category.html'
import controller from './category.controller'
import './category.scss'

let module = angular.module('category', [
	'ionic'
])
.config(($stateProvider) => {
	"ngInject";

	$stateProvider
		.state('tab.category', {
			url: '/category',
			views: {
				'tab-search': {
					template: template,
					controller: controller,
					controllerAs: 'category'
				}
			},
		})
})
.name;

export default module;


// WEBPACK FOOTER //
// ./app/components/category/category.js